module.exports = __webpack_public_path__ + "static/media/life.6fb04744.jpg";